import { writable, readable, derived } from 'svelte/store';
import { Database, aql } from "arangojs/web"
import { geoMercator } from 'd3-geo';

export const projection = geoMercator()
        .scale(800000)
        .translate([0,0])
        .rotate([-24.867,-36.069])

export const db = new Database({
    url: "http://35.187.27.74:8529",
    databaseName: "vast2021",
    auth: { username: "vast_user", password: "aTh3aifa" }
    //   auth: { username: "JanAerts", password: "arJ0zieth-" }

    // url: "http://localhost:8529",
    // databaseName: "VAST2021",
    // auth: { username: "jandot", password: "arJ0zieth-" }

});

export const car_encounters = writable([])
db.collection('ja_car_encounters').all()
    .then(
        cursor => cursor.map(doc => doc)
    )
    .then(
        data => car_encounters.set(data)
    )

export const c2l_datapoints = writable([])
db.collection('ja_creditcard2loyaltycard').all()
    .then(
        cursor => cursor.map(doc => doc)
    )
    .then(
        data => c2l_datapoints.set(data)
    )

export const gps_stationary_datapoints = writable([])
db.collection('ja_stationary_car_positions_method2').all()
    .then(
        cursor => cursor.map(doc => doc)
    )
    .then(
        data => gps_stationary_datapoints.set(data)
    )

export const fetching_gps_data = writable(true)
export const gps_datapoints = writable([])

// db.collection('ja_car_positions').byExample({car_id: 1}) //all()
db.query(aql`
    FOR x IN ja_avg_car_positions
    RETURN x
    `)
    .then(
        cursor => cursor.map(doc => doc)
    )
    .then(
        data => { gps_datapoints.set(data); fetching_gps_data.set(false) }
    )

// export const cars = writable([])
// db.query(aql`
//     FOR x IN ja_car_positions
//     RETURN DISTINCT x.car_id
//     `).then(
//         cursor => cursor.map(doc => doc)
//     )
//     .then(
//         data => { cars.set(data) }
//     )
